export default __webpack_public_path__ + "static/media/testimonials@2x.188666c4.png";